/*
We initialize these image uploads separately because of the order the modules have to be initialized.
 */

import simpleImageUpload from '../components/simple-image-upload';

let instance = {},
    settings = {
        boundAttr: 'data-bound',
        simpleImageUploadClass: 'm-image-upload-simple'
    };

instance.init = () => {
    let containers = document.querySelectorAll(`.${settings.simpleImageUploadClass}:not([${settings.boundAttr}])`);

    containers.forEach((el) => {
        simpleImageUpload(el);
    });
};

export default instance;
